import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.helpers.customFields', {
    mandatoryFieldsError: 'Please fill all mandatory fields.',
    emailError: 'Email address is invalid.',
    phoneError: 'Phone number is invalid.',
    hyperLinkError: 'Hyperlink is invalid.',
});
